export default __webpack_public_path__ + "static/media/zanskar2.6bf29969.jpg";